module.exports = __webpack_public_path__ + "static/media/citrinedp.d681be8e.jpg";